<script>
  import { _ as t } from "svelte-i18n";
  import { Link } from "svelte-routing";

  let openMenu = false;

  const handleMenuClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    openMenu = true;
  };

  const handleHideMenu = () => {
    openMenu = false;
  };

  const getProps = ({ href, isPartiallyCurrent, isCurrent }) => {
    const isActive = href === "/" ? isCurrent : isPartiallyCurrent || isCurrent;

    // The object returned here is spread on the anchor element's attributes
    if (isActive) {
      return { class: "menu-item active" };
    }
    return { class: "menu-item" };
  };

  const getDeskProps = ({ href, isPartiallyCurrent, isCurrent }) => {
    const isActive = href === "/" ? isCurrent : isPartiallyCurrent || isCurrent;

    // The object returned here is spread on the anchor element's attributes
    if (isActive) {
      return { class: "menu-desk-item active" };
    }
    return { class: "menu-desk-item" };
  };
</script>

<svelte:window on:click={handleHideMenu} />
<div class="desktop">
  <Link getProps={getDeskProps} to="/">{$t("common.home")}</Link>
  <Link getProps={getDeskProps} to="/blog">{$t("common.blog")}</Link>
  <Link getProps={getDeskProps} to="/events">{$t("common.events")}</Link>
  <Link getProps={getDeskProps} to="/workshops">{$t("common.workhops")}</Link>
</div>

<div on:click={handleMenuClick} class="mobile-menu-icon">
  <svg
    width="24"
    height="24"
    xmlns="http://www.w3.org/2000/svg"
    fill-rule="evenodd"
    clip-rule="evenodd"
    ><path
      d="M24 18v1h-24v-1h24zm0-6v1h-24v-1h24zm0-6v1h-24v-1h24z"
      fill="#1040e2"
    /><path d="M24 19h-24v-1h24v1zm0-6h-24v-1h24v1zm0-6h-24v-1h24v1z" /></svg
  >
</div>
{#if openMenu}
  <div class="overlay">
    <div class="menu-wrapper">
      <div class="menu-inner">
        <Link {getProps} to="/">{$t("common.home")}</Link>
        <Link {getProps} to="/blog">{$t("common.blog")}</Link>
        <Link {getProps} to="/events">{$t("common.events")}</Link>
        <Link {getProps} to="/workshops">{$t("common.workhops")}</Link>
      </div>
    </div>
  </div>
{/if}

<style>
  .mobile-menu-icon {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 4px;
    margin: 24px 0;
    text-transform: uppercase;
    text-align: right;
    font-size: 18px;
    color: #999;
    border: none;
    outline: none;
    background-color: inherit;
    cursor: pointer;
  }

  @media only screen and (min-width: 600px) {
    .mobile-menu-icon {
      display: none;
    }
  }

  .mobile-menu-icon svg {
    fill: currentColor;
  }

  .mobile-menu-icon:hover {
    color: black;
  }

  /* Menu */
  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: #999;
    z-index: 9999;
  }

  .menu-wrapper {
    position: relative;
    margin: 0 auto;
    max-width: 900px;
    text-align: center;
    height: 100%;
  }

  .menu-inner {
    max-width: 600px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
  }

  .menu-wrapper :global(.menu-item) {
    margin: 24px 0;
    text-transform: uppercase;
    font-size: 24px;
    color: white;
  }

  .menu-wrapper :global(.menu-item:hover) {
    color: black;
  }

  .menu-wrapper :global(.menu-item.active) {
    color: black;
  }

  .desktop {
    display: none;
  }

  :global(a.menu-desk-item) {
    margin: 6px 0;
    text-transform: uppercase;
    font-size: 18px;
    color: #999;
  }

  :global(.menu-desk-item.active) {
    color: black;
  }

  :global(.menu-desk-item:hover) {
    color: black;
  }

  @media only screen and (min-width: 600px) {
    .desktop {
      display: flex;
      flex-direction: column;
      text-align: right;
    }
  }
</style>
